import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import confirmation from "@/plugins/confirmation";
import store from './store'
import loader from "@/plugins/loader";
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'
import VueCookies from 'vue-cookies'
import { VueTypedJs } from 'vue-typed-js'
import VueApexCharts from 'vue-apexcharts'
import CodeEditor from 'simple-code-editor';
//packages
import Dashboard from "@/packages/dashboard";
//
//
import toastr from "../shared/toastr";
import Landing from "@/packages/Landing";
//guest modules

import appAlert from "@/plugins/appAlert";
import Solution from "@/packages/solutions";
import APIReference from "@/packages/c2bModules/GettingStarted";
import Product from "@/packages/Product";
import Partners from "@/packages/Partners";
import SDK from "@/packages/SDK";
import ApiAuthentication from "@/packages/c2bModules/ApiAuthentication";
import SasaPayProducts from "@/packages/c2bModules/SasaPayC2B";
import SasaPayB2C from "@/packages/c2bModules/SasaPayB2C";
import RedirectToAPI from "@/packages/RedirectToAPI";
import SasaPayQueryMerchant from "@/packages/c2bModules/SasaPayQueryMerchant";
import SasaPayIPN from "@/packages/c2bModules/SasaPayIPN";
import SasaPayVerifyTransaction from "@/packages/c2bModules/SasaPayVerifyTransaction";
import SasaPayCheckTransactionStatus from "@/packages/c2bModules/SasaPayCheckTransactionStatus";
import WaasAuthentication from "@/packages/WaasModules/WaasAuthentication";
import Onboarding from "@/packages/WaasModules/Onboarding";
import Beneficiary from "@/packages/WaasModules/Beneficiary";
import Merchant from "@/packages/WaasModules/Merchant";
import Payments from "@/packages/WaasModules/Payments";
import TransactionStatus from "@/packages/WaasModules/TransactionStatus";
import ChannelCodes from "@/packages/WaasModules/ChannelCodes";
import NearestAgents from "@/packages/WaasModules/NearestAgents";
import LoyaltyPoints from "@/packages/WaasModules/LoyaltyPoints";
import UtilityPayments from "@/packages/WaasModules/UtilityPayments";
import otpInput from "@/plugins/otpInput";
import titleMixin from './mixins/titleMixin'
import VueTyperPlugin from 'vue-typer'
import Simulator from "@/packages/Simulator";
import VueScrollTo from 'vue-scrollto'
import GoTop from "@inotom/vue-go-top";
Vue.config.productionTip = false
//
Vue.use(loader);
Vue.use(Toast);
Vue.use(VueTypedJs)
Vue.use(confirmation)
Vue.use(appAlert)
Vue.use(otpInput)
//scroller
Vue.use(VueScrollTo)
Vue.use(GoTop);
//
Vue.component('apexchart', VueApexCharts)
Vue.component('code-editor', CodeEditor)
Vue.use(VueTyperPlugin)

// default options config: { expires: '1d', path: '/', domain: '', secure: '', sameSite: 'Lax' }
Vue.use(VueCookies, { expire: '7d'})
const options = {
  store,
  router,
}
Vue.use(Dashboard, options)
Vue.use(Landing, options)
Vue.use(Solution,options)
Vue.use(Product,options)
Vue.use(Partners,options)
Vue.use(RedirectToAPI,options)
Vue.use(SDK,options)
//simulator
Vue.use(Simulator,options)
//check if waas
const isWaas=localStorage.getItem("isWaas")

//on the dashboard C2B
if (isWaas==="true") {
  Vue.use(APIReference,options)
  Vue.use(WaasAuthentication,options)
  Vue.use(Onboarding,options)
  //beneficiary
  Vue.use(Beneficiary,options)
  Vue.use(Merchant,options)
  //payments
  Vue.use(Payments,options)
  //utility payments
  Vue.use(UtilityPayments,options)
  //loyalty points
  Vue.use(LoyaltyPoints,options)
  //query status
  Vue.use(TransactionStatus,options)
  //channel codes
  Vue.use(ChannelCodes,options)
  //nearest agents
  Vue.use(NearestAgents,options)
} if (isWaas){
  Vue.use(ApiAuthentication,options)
  Vue.use(SasaPayProducts,options)//c2b
  Vue.use(SasaPayB2C,options)
  Vue.use(SasaPayQueryMerchant,options)
  Vue.use(SasaPayIPN,options)
  Vue.use(SasaPayCheckTransactionStatus,options)
  Vue.use(SasaPayVerifyTransaction,options)
  //show nothing
}
//END C2B


new Vue({
  router,
  vuetify,
  store,
  mixins: [toastr,titleMixin],
  render: h => h(App)
}).$mount('#app')
